import React from 'react';
import Box from 'relements/build/esm/ui/box';

import Skeleton from '@src/components/Skeleton';
import { Grid } from '../ToolList/styledComponent';
import { Container } from './styledComponents';

function HomeLoading() {
  return (
    <Container>
      <Box padding="zero" flexDirection="column">
        <Skeleton height="25px" width="200px" animation />
        <Skeleton height="25px" width="120px" marginTop="22px" animation />
        <Skeleton height="90px" width="620px" marginTop="16px" animation />
        <Skeleton height="45px" width="620px" marginTop="12px" animation />
        <Skeleton height="25px" width="120px" marginTop="50px" animation />
        <Grid gridGap={10}>
          {[...Array(6)].map(() => (
            <Skeleton height="72px" width="303px" animation />
          ))}
        </Grid>
      </Box>
    </Container>
  );
}

export default React.memo(HomeLoading);
